module.exports = __webpack_public_path__ + "images/emoji/boy.e017dadb6a522b7e58c0.png";